import { notifications } from '@markku/db'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'
import { z } from 'zod'

export const selectNotificationSchema = createSelectSchema(notifications)
export const insertNotificationSchema = createInsertSchema(notifications).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
})

export type Notification = z.infer<typeof selectNotificationSchema>
export type InsertNotification = z.infer<typeof insertNotificationSchema>

// Notification types enum (can expand as needed)
export const NOTIFICATION_TYPES = {
  VISIT_FEEDBACK_REQUEST: 'visit_feedback_request',
  CHAT_MESSAGE: 'chat_message',
  VISIT_REMINDER: 'visit_reminder',
  INVOICE_EMAIL: 'invoice_email',
  CHIMNEY_SWEEP_REMINDER: 'chimney_sweep_reminder',
  COMMISSION_CONGRATULATIONS: 'commission_congratulations',
} as const

export type NotificationType =
  (typeof NOTIFICATION_TYPES)[keyof typeof NOTIFICATION_TYPES]

// Notification channels
export const NOTIFICATION_CHANNELS = {
  EMAIL: 'email',
  PUSH: 'push',
  SMS: 'sms',
} as const

export type NotificationChannel =
  (typeof NOTIFICATION_CHANNELS)[keyof typeof NOTIFICATION_CHANNELS]

// Notification status
export const NOTIFICATION_STATUS = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  SENT: 'sent',
  SKIPPED: 'skipped',
  FAILED: 'failed',
} as const

export type NotificationStatus =
  (typeof NOTIFICATION_STATUS)[keyof typeof NOTIFICATION_STATUS]
